<template>
  <v-footer dark>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-tooltip top
                   v-for="(methodOfContact, index) in methodsOfContactForFooter"
                   :key="index"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-4"
                   icon
                   :href="methodOfContact.url"
                   target="_blank"
                   @click="logAnalyticEvent(methodOfContact.name)"
                   v-bind="attrs"
                   v-on="on"
            >
              <v-icon size="24px">{{ methodOfContact.icon }}</v-icon>
            </v-btn>
          </template>
          <span>{{ methodOfContact.name }}</span>
        </v-tooltip>
      </v-col>

      <v-col cols="12" class="caption text-center font-weight-light">
        &copy; {{ new Date().getFullYear() }} {{ applicationName }}
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: "Footer",
  methods: {
    logAnalyticEvent(eventType) {
      this.$gtag.event(`${eventType.toLowerCase()}`, {event_category: 'footer'});
    },
  },
  computed: {
    ...mapGetters(["methodsOfContactForFooter"]),
    ...mapState(["applicationName"]),
  },
}
</script>
